import React from 'react';
import PropTypes from 'prop-types';

const ShieldCheck = ({ size }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 18 18"
  >
    <path
      fill="#3CAFFF"
      d="M9.748 8.25h6.75v-6h-.75c-2.02 0-3.94-.402-6-1.25z"
    ></path>
    <path
      fill="#008AEA"
      d="M8.25 1c-2.06.848-3.98 1.25-6 1.25H1.5v6h6.75z"
    ></path>
    <path
      fill="#9FD8FF"
      d="M9.748 9.75v7.308c1.577-.523 5.88-2.394 6.629-7.308z"
    ></path>
    <path
      fill="#3CAFFF"
      d="M8.25 9.75H1.62c.75 4.914 5.051 6.785 6.629 7.308z"
    ></path>
  </svg>
);

ShieldCheck.propTypes = {
  size: PropTypes.number,
};

ShieldCheck.defaultProps = {
  size: 18
};

export default ShieldCheck;
